import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { StyledEngineProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';

import Routes from 'config/routes';

import './index.css';
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <StyledEngineProvider>
      <CssBaseline />
      <Routes />
      <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar
          newestOnTop
          closeOnClick
          rtl={false}
          draggable
          pauseOnHover={false}
        />
    </StyledEngineProvider>
  );
}

export default App;
